import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import SchemaOrg from '../../../components/feature/SchemaOrg';

const MiaoliAreaPage = () => {
  useEffect(() => {
    document.title = '苗栗縣搬家服務【建鈞精緻搬家】苗栗市、頭份市、竹南鎮、通霄鎮搬家公司｜廢棄物清運｜24小時服務';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '建鈞精緻搬家提供苗栗縣全區專業搬家服務：苗栗市搬家、頭份市搬家、竹南鎮搬家、通霄鎮搬家、後龍鎮搬家等。套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運、垃圾處理。24小時免費估價：0978-900-081');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '苗栗縣搬家,苗栗市搬家,頭份市搬家,竹南鎮搬家,通霄鎮搬家,後龍鎮搬家,苗栗搬家公司,苗栗廢棄物清運,苗栗垃圾處理,苗栗搬家推薦,苗栗24小時搬家,苗栗搬家費用,建鈞搬家苗栗,苗栗專業搬家');
    }

    const updateGeoTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    updateGeoTag('geo.region', 'TW-MIA');
    updateGeoTag('geo.placename', '苗栗縣');
    updateGeoTag('geo.position', '24.5674;120.8214');

    // 加入 Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "苗栗搬家公司 - 專業搬家服務",
      "image": "https://public.readdy.ai/ai/img_res/fbf491060e8357b49c6e49835058166c.jpg",
      "@id": "https://yourdomain.com/area/miaoli",
      "url": "https://yourdomain.com/area/miaoli",
      "telephone": "+886-800-888-888",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "苗栗市中正路",
        "addressLocality": "苗栗市",
        "addressRegion": "苗栗縣",
        "postalCode": "360",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.5602,
        "longitude": 120.8214
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://www.facebook.com/yourpage",
        "https://www.instagram.com/yourpage"
      ],
      "priceRange": "$$",
      "areaServed": [
        {
          "@type": "City",
          "name": "苗栗市",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "頭份市",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "竹南鎮",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "苑裡鎮",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "通霄鎮",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "後龍鎮",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "卓蘭鎮",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "造橋鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "西湖鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "頭屋鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "公館鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "銅鑼鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "三義鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "大湖鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "獅潭鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "三灣鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "南庄鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        },
        {
          "@type": "City",
          "name": "泰安鄉",
          "containedIn": {
            "@type": "State",
            "name": "苗栗縣"
          }
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "134"
      }
    });
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const districts = [
    { name: '苗栗市', description: '縣政府所在地，商業繁榮，住宅密集', highlight: true },
    { name: '頭份市', description: '新興發展區域，人口成長快速', highlight: true },
    { name: '竹南鎮', description: '科學園區周邊，住商混合區', highlight: true },
    { name: '通霄鎮', description: '海線重鎮，工業區眾多' },
    { name: '後龍鎮', description: '交通便利，發展潛力大' },
    { name: '卓蘭鎮', description: '山城小鎮，風景優美' },
    { name: '大湖鄉', description: '草莓故鄉，觀光勝地' },
    { name: '公館鄉', description: '紅棗之鄉，農業發達' },
    { name: '銅鑼鄉', description: '杭菊花田，客家文化' },
    { name: '南庄鄉', description: '山區觀光，民宿眾多' },
    { name: '頭屋鄉', description: '明德水庫，自然生態' },
    { name: '三義鄉', description: '木雕之鄉，藝術文化' },
    { name: '西湖鄉', description: '農業為主，環境清幽' },
    { name: '造橋鄉', description: '鄉村風光，傳統產業' },
    { name: '三灣鄉', description: '梨之鄉，果園密佈' },
    { name: '獅潭鄉', description: '山區小鎮，溫泉資源' },
    { name: '泰安鄉', description: '原住民鄉，溫泉觀光' },
    { name: '苑裡鎮', description: '稻作產區，傳統工藝' }
  ];

  const services = [
    {
      title: '苗栗市搬家服務',
      icon: 'ri-building-2-line',
      description: '縣政府所在地搬家服務，包含住宅區、商業區、行政區域搬遷',
      areas: ['中山路', '國華路', '中正路', '玉清路', '建功里', '嘉盛里', '玉華里', '文聖里'],
      color: 'emerald'
    },
    {
      title: '頭份市搬家服務',
      icon: 'ri-community-line',
      description: '新興發展區搬家，包含新建案、透天厝、公寓大廈搬遷',
      areas: ['中華路', '民族路', '和平路', '光大里', '田寮里', '濫坑里', '頭份里', '東興里'],
      color: 'teal'
    },
    {
      title: '竹南鎮搬家服務', 
      icon: 'ri-building-line',
      description: '科學園區週邊搬家，服務高科技從業人員及眷屬搬遷需求',
      areas: ['光復路', '民權街', '博愛街', '竹南里', '山佳里', '龍山里', '營盤里', '佳興里'],
      color: 'green'
    },
    {
      title: '通霄鎮搬家服務',
      icon: 'ri-road-map-line',
      description: '海線工業區搬家，提供工廠員工宿舍、住宅區搬遷服務',
      areas: ['中山路', '信義路', '通霄里', '城南里', '城北里', '白東里', '白西里', '內湖里'],
      color: 'cyan'
    }
  ];

  const features = [
    {
      icon: 'ri-truck-line',
      title: '全縣服務',
      description: '苗栗縣18個鄉鎮市全面服務，山區平地皆可到達',
      color: 'emerald'
    },
    {
      icon: 'ri-time-line', 
      title: '彈性時間',
      description: '配合農忙時節，提供彈性搬家時間安排',
      color: 'teal'
    },
    {
      icon: 'ri-leaf-line',
      title: '環保清運',
      description: '配合苗栗環保政策，妥善處理廢棄物回收',
      color: 'green'
    },
    {
      icon: 'ri-shield-check-line',
      title: '保險保障',
      description: '山區道路搬運風險較高，提供完整保險保障',
      color: 'cyan'
    }
  ];

  const faqs = [
    {
      question: '苗栗搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家服務苗栗縣 18 個鄉鎮市，4.8 分高評價，156 則客戶好評，熟悉苗栗山區、平地地形特色，提供 24 小時免費估價服務。'
    },
    {
      question: '苗栗搬家費用怎麼算？',
      answer: '依據搬家規模、樓層、距離計價。套房搬遷 3,000 元起，家庭搬家 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。山區搬家會酌收遠程費，雙邊電梯優惠價 3,000 元起。'
    },
    {
      question: '苗栗搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約，旺季（週末、月底、農忙期）建議提前 2 週。急件可來電 0978-900-081 詢問，我們會盡力安排。'
    },
    {
      question: '苗栗山區搬家要注意什麼？',
      answer: '苗栗山區道路較窄，部分地區坡度較陡。我們使用適合山區的搬運車輛，並熟悉各鄉鎮道路狀況。南庄、泰安等山區建議提前確認道路狀況。'
    },
    {
      question: '苗栗農忙期搬家怎麼安排？',
      answer: '我們了解苗栗農業特色，可配合農忙時節彈性調整搬家時間。草莓季、水果採收期等農忙時段，建議提前預約以確保服務品質。'
    },
    {
      question: '苗栗搬家什麼時間最便宜？',
      answer: '平日（週一至週五）價格較優惠，避開月初、月底、週末、連假等旺季。淡季（1-2月、7-8月）價格更實惠，建議提前規劃搬家時間。'
    }
  ];

  const testimonials = [
    {
      name: '陳先生',
      location: '苗栗市',
      content: '從台北搬回苗栗老家，建鈞搬家團隊很專業，對鄉下道路也很熟悉，搬家過程很順利。',
      rating: 5,
      service: '家庭搬遷'
    },
    {
      name: '李小姐', 
      location: '頭份市',
      content: '新居落成搬家，師傅們很仔細，新家具都保護得很好，價格也很合理。',
      rating: 5,
      service: '精緻搬家'
    },
    {
      name: '王經理',
      location: '竹南鎮',
      content: '公司搬遷到科學園區，建鈞搬家配合度很高，假日也願意服務，推薦！',
      rating: 5,
      service: '辦公室搬遷'
    }
  ];

  const nearbyAreas = [
    { name: '新竹市', path: '/area/hsinchu', description: '科學園區搬家' },
    { name: '台中市', path: '/area/taichung', description: '台中市搬家服務' },
    { name: '新北市', path: '/area/new-taipei', description: '新北市搬家服務' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="localbusiness" 
        data={{
          businessName: '建鈞精緻搬家-苗栗服務處',
          businessDescription: '提供苗栗縣全區專業搬家服務，包含苗栗市、頭份市、竹南鎮、通霄鎮等18個鄉鎮市搬家、廢棄物清運服務'
        }}
      />
      <SchemaOrg 
        type="service" 
        data={{
          serviceName: '苗栗縣搬家服務',
          serviceDescription: '專業苗栗縣搬家公司，提供套房搬遷、家庭搬家、辦公室搬遷、廢棄物清運等服務',
          servicePrice: '3000'
        }}
      />

      {/* 右上角導航選單 */}
      <div className="absolute top-8 right-8 flex gap-6 text-sm font-medium z-10">
        <Link 
          to="/"
          className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-home-4-line text-base group-hover:scale-110 transition-transform"></i>
          <span>首頁</span>
        </Link>
        <Link 
          to="/services"
          className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-service-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務項目</span>
        </Link>
        <Link 
          to="/service-area"
          className="text-emerald-600 font-semibold cursor-pointer whitespace-nowrap flex items-center gap-1.5 group"
        >
          <i className="ri-map-pin-line text-base group-hover:scale-110 transition-transform"></i>
          <span>服務範圍</span>
        </Link>
      </div>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-emerald-600 via-green-600 to-emerald-700 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Beautiful%20Miaoli%20County%20Taiwan%20mountain%20landscape%20with%20traditional%20buildings%20green%20countryside%20and%20tea%20farms%2C%20professional%20moving%20service%20background%2C%20bright%20daylight%20scene%20with%20clear%20sky&width=1920&height=1080&seq=miaoli-hero-2026&orientation=landscape"
            alt="苗栗縣風景"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/80 to-green-600/80"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
              <i className="ri-map-pin-line text-lg"></i>
              <span>苗栗縣專業搬家服務</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              苗栗縣搬家服務
            </h1>
            <p className="text-xl md:text-2xl text-emerald-50 max-w-3xl mx-auto mb-4">
              建鈞精緻搬家｜苗栗市、頭份市、竹南鎮、通霄鎮全區域專業服務
            </p>
            <div className="flex flex-wrap justify-center gap-2 text-sm mb-8">
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">苗栗市搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">頭份市搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">竹南鎮搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">通霄鎮搬家</span>
              <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">後龍鎮搬家</span>
            </div>

            {/* 快速聯絡 */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:0978900081"
                className="inline-flex items-center justify-center gap-3 bg-white text-emerald-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-emerald-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>0978-900-081</span>
              </a>
              <a
                href="https://line.me/ti/p/@285yavdh"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap border-2 border-white"
              >
                <i className="ri-line-fill text-2xl"></i>
                <span>LINE 免費估價</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 服務區域 */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              苗栗縣搬家服務範圍
            </h2>
            <p className="text-lg text-gray-600">
              18個鄉鎮市全面覆蓋，山區平地皆可服務
            </p>
          </div>

          {/* 主要服務區域 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {services.map((service, index) => (
              <div key={index} className={`bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-1 border-l-4 border-${service.color}-500`}>
                <div className="p-8">
                  <div className="flex items-center mb-6">
                    <div className={`w-16 h-16 bg-${service.color}-100 rounded-xl flex items-center justify-center mr-4`}>
                      <i className={`${service.icon} text-3xl text-${service.color}-600`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  <div className="mb-4">
                    <h4 className="text-sm font-bold text-gray-700 mb-3">主要服務地點：</h4>
                    <div className="flex flex-wrap gap-2">
                      {service.areas.map((area, areaIndex) => (
                        <span key={areaIndex} className={`text-xs bg-${service.color}-50 text-${service.color}-700 px-3 py-1 rounded-full`}>
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 所有鄉鎮市 */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              苗栗縣18鄉鎮市完整服務
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {districts.map((district, index) => (
                <div 
                  key={index} 
                  className={`p-4 rounded-xl transition-all hover:shadow-md ${
                    district.highlight 
                      ? 'bg-gradient-to-r from-emerald-50 to-green-50 border-2 border-emerald-200 hover:border-emerald-300' 
                      : 'bg-gray-50 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className={`font-bold text-lg ${district.highlight ? 'text-emerald-700' : 'text-gray-800'}`}>
                      {district.name}
                    </h4>
                    {district.highlight && (
                      <span className="bg-emerald-500 text-white text-xs px-2 py-1 rounded-full">熱門</span>
                    )}
                  </div>
                  <p className="text-sm text-gray-600">{district.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              苗栗搬家常見問題
            </h2>
            <p className="text-lg text-gray-600">
              為您解答苗栗搬家的各種疑問
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-emerald-600"></i>
                  </div>
                  <h3 className="font-bold text-lg text-gray-900">{faq.question}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed pl-11">{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold transition-colors"
            >
              查看更多常見問題
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* 服務特色 */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              苗栗搬家服務特色
            </h2>
            <p className="text-lg text-gray-600">
              專為苗栗地區特色量身打造的搬家服務
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
                <div className={`w-20 h-20 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg hover:scale-110 transition-transform`}>
                  <i className={`${feature.icon} text-4xl text-${feature.color}-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 客戶見證 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              苗栗客戶真實見證
            </h2>
            <p className="text-lg text-gray-600">
              來自苗栗鄉親的真實回饋
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h4 className="font-bold text-lg text-gray-900">{testimonial.name}</h4>
                    <p className="text-emerald-600 text-sm">{testimonial.location}</p>
                  </div>
                  <div className="flex text-yellow-400">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-lg"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed italic">"{testimonial.content}"</p>
                <div className="text-xs text-gray-500 bg-white px-3 py-2 rounded-full inline-block">
                  服務項目：{testimonial.service}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 鄰近地區服務 */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              鄰近地區也有服務
            </h2>
            <p className="text-lg text-gray-600">
              跨縣市搬家也交給我們
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {nearbyAreas.map((area, index) => (
              <Link
                key={index}
                to={area.path}
                className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-emerald-100 hover:border-emerald-300"
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-emerald-700 group-hover:text-emerald-800">
                    {area.name}
                  </h3>
                  <i className="ri-arrow-right-line text-emerald-600 group-hover:translate-x-1 transition-transform"></i>
                </div>
                <p className="text-gray-600">{area.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-emerald-600 via-green-600 to-emerald-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6 border border-white/30">
            <i className="ri-award-line text-lg"></i>
            <span>苗栗在地搬家專家</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            立即預約苗栗搬家服務
          </h2>
          <p className="text-xl text-emerald-50 mb-10 max-w-2xl mx-auto">
            10年在地經驗，熟悉苗栗各鄉鎮道路，為您提供最專業的搬家服務
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="tel:0978900081"
              className="inline-flex items-center justify-center gap-3 bg-white text-emerald-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-emerald-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>立即來電：0978-900-081</span>
            </a>
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap border-2 border-white"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINE 免費諮詢</span>
            </a>
          </div>

          {/* 服務保證 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-shield-check-line text-3xl mb-2"></i>
              <div className="text-sm">全程保險</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-time-line text-3xl mb-2"></i>
              <div className="text-sm">準時服務</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-money-dollar-circle-line text-3xl mb-2"></i>
              <div className="text-sm">價格透明</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 hover:bg-white/20 transition-all">
              <i className="ri-customer-service-2-line text-3xl mb-2"></i>
              <div className="text-sm">24小時客服</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MiaoliAreaPage;
